import { createFileRoute, notFound } from "@tanstack/react-router";

import { LimitsPageView } from "@/components/marketing/limits-page";
import { NotFoundPage } from "@/components/marketing/not-found-page";
import { limitsPageHead } from "@/lib/seo";

/**
 * The limits data comes from the loader, not a module-scope import: `head` is
 * not code-split, so a static import would put every limits table in the
 * app's entry chunk. See `help.$slug`.
 */
export const Route = createFileRoute("/(public)/limits/$network")({
  loader: async ({ params }) => {
    const { getLimitsPage } = await import(
      "@/components/marketing/limits-data"
    );
    const page = getLimitsPage(params.network);

    if (!page) {
      throw notFound();
    }

    return { page };
  },
  head: ({ loaderData }) =>
    loaderData?.page ? limitsPageHead(loaderData.page) : {},
  notFoundComponent: NotFoundPage,
  component: LimitsRoute,
});

function LimitsRoute() {
  const { page } = Route.useLoaderData();

  return <LimitsPageView page={page} />;
}
